import React from "react";
import { tickerList } from "../data";

export default function Ticker() {
  // Render the list twice back-to-back for a seamless CSS scroll loop
  const doubledList = [...tickerList, ...tickerList];

  return (
    <div className="mu-ticker">
      <div className="mu-ticker-track">
        {doubledList.map((item, i) => (
          <span className="mu-tick-item" key={i}>
            <span className="mu-tick-num">{item.n}</span>
            {item.t} <span className="mu-tick-artist">{item.a}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
